<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xURgxM/tc-custom/1.png?1685327829134?1709061746923" alt="This image is the cover for the book Be Positive with Lola"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Be Positive with Lola
      </h1>
      <p class="bookDescription body article font2">
        <p>Lola isn't the 'popular one' at school and she doesn't go without her struggles. She does, however, approach her daily life with positivity, kindness and a beaming smile! Allow Lola to show you that we all have that inner sunshine and the more we let it show, the happier our days can be! You don't have to be extraordinary to feel extraordinary.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Miss B
      </h2>
      
      <p class="authorDescription body article">Miss B is a hugely motivated individual with a massive zest for life who began writing for personal enjoyment shortly after giving birth to her daughter. Her journey with mindfulness began at this time and this inspired her to write her debut publication; Be Positive with Lola. She hopes to show children from a very young age that with positive thinking and kindness, comes happiness. Mel spends her days providing office support for a car performance garage, teaches fitness classes, writes when she can and best of all, spends time with her loved ones. She describes herself as "a busy Mum who loves life and the people she's lucky enough to share it with."</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f015c3e6